enum WeightResponsibleEnum {
  SELLER = "SELLER",
  BUYER = "BUYER",
}

export default WeightResponsibleEnum;
